@if (loading) {
    <div class="page"><app-spinner [fullscreen]="false"></app-spinner></div>
} @else if (error) {
    <app-error-ficha [mensaje]="error" (reintentar)="reintentar()" (volver)="volverAlListado()"></app-error-ficha>
} @else {
    @if (showEdit) {
        <div class="page page--form">
            <app-formulario
                [title]="'Editar cargo'"
                [buttons]="buttons"
                [fields]="fields"
                [type]="type"
                [functionSelected]="FunctionsAvailable.cargosPut">
            </app-formulario>
        </div>
    } @else {
        <div class="page">
            <section class="ficha-hero" data-seccion="cargos" aria-labelledby="ficha-titulo">
                <div class="ficha-hero__back">
                    <button type="button" class="back-link" data-testid="volver" (click)="goBack()"><i class="bi bi-arrow-left" aria-hidden="true"></i>Volver a cargos</button>
                </div>
                <div class="ficha-hero__top">
                    <span class="page-header__icon ficha-hero__icon" data-seccion="cargos" aria-hidden="true"><i class="bi bi-award-fill"></i></span>
                    <div class="ficha-hero__id">
                        <h1 id="ficha-titulo">{{ item.nombre }}</h1>
                        @if (ejercicioMostrado) { <p class="meta">Titulares del ejercicio {{ ejercicioMostrado }}</p> }
                    </div>
                    <div class="ficha-hero__actions">
                        <div class="dropdown">
                            <button class="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="bi bi-three-dots-vertical" aria-hidden="true"></i>Acciones
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end">
                                <li><button type="button" class="dropdown-item" (click)="editItem()"><i class="bi bi-pencil-square" aria-hidden="true"></i>Editar</button></li>
                                <li><button type="button" class="dropdown-item" (click)="downloadExcel()"><i class="bi bi-file-earmark-arrow-down-fill" aria-hidden="true"></i>Descargar datos</button></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="tabs" role="tablist" aria-label="Titulares por tipo de asociación" appTabsNav>
                    <button type="button" role="tab" class="tab" id="tab-fogueres" [attr.aria-selected]="viewMode === ViewMode.FOGUERES" [attr.tabindex]="viewMode === ViewMode.FOGUERES ? 0 : -1" (click)="changeMode(ViewMode.FOGUERES)">Fogueres</button>
                    <button type="button" role="tab" class="tab" id="tab-barracas" [attr.aria-selected]="viewMode === ViewMode.BARRACAS" [attr.tabindex]="viewMode === ViewMode.BARRACAS ? 0 : -1" (click)="changeMode(ViewMode.BARRACAS)">Barracas</button>
                </div>
            </section>

            @if (viewMode === ViewMode.FOGUERES) {
                <div role="tabpanel" aria-labelledby="tab-fogueres">
                    <app-listado
                        [filter]="[{name: 'tipoAsociaciones', condition: 2}]"
                        [items]="asociados"
                        [type]="ItemType.CARGOASOCIADOASOCIACION"
                        (openItem)="emitOpenItem($event, 'Asociados', item)"
                    ></app-listado>
                </div>
            }
            @if (viewMode === ViewMode.BARRACAS) {
                <div role="tabpanel" aria-labelledby="tab-barracas">
                    <app-listado
                        [filter]="[{name: 'tipoAsociaciones', condition: 1}]"
                        [items]="asociados"
                        [type]="ItemType.CARGOASOCIADOASOCIACION"
                        (openItem)="emitOpenItem($event, 'Asociados', item)"
                    ></app-listado>
                </div>
            }
        </div>
    }
}
